import { AttatchFileTrainContainer } from "../../../containers/borrowSystem/BorrowForm/AttatchFileTrainContainer"

export function AttatchFileTrainPage() {
    return (
        <AttatchFileTrainContainer />
    )
}